import api from "./api";
import { getFullLogoUrl } from "../utils/urlUtils";

export const companyService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/companies", { params });

      // Process companies to add full logo URLs
      if (response.data.companies) {
        response.data.companies = response.data.companies.map((company) => {
          const fullLogoUrl = getFullLogoUrl(company.logo);
          console.log("Processing company logo:", {
            companyId: company.id,
            companyName: company.name,
            originalLogo: company.logo,
            fullLogoUrl: fullLogoUrl,
          });
          return {
            ...company,
            logo: fullLogoUrl,
          };
        });
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/companies/${id}`);

      // Process company to add full logo URL
      if (response.data) {
        response.data.logo = getFullLogoUrl(response.data.logo);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(companyData) {
    try {
      const response = await api.post("/companies", companyData);

      // Process company to add full logo URL
      if (response.data) {
        response.data.logo = getFullLogoUrl(response.data.logo);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, companyData) {
    try {
      const response = await api.put(`/companies/${id}`, companyData);

      // Process company to add full logo URL
      if (response.data) {
        response.data.logo = getFullLogoUrl(response.data.logo);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/companies/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async toggleStatus(id) {
    try {
      const response = await api.patch(`/companies/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async uploadLogo(id, logoFile) {
    try {
      const formData = new FormData();
      formData.append("logo", logoFile);
      const response = await api.post(`/companies/${id}/logo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Process response to add full logo URL
      if (response.data) {
        response.data.logo = getFullLogoUrl(response.data.logo);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteLogo(id) {
    try {
      const response = await api.delete(`/companies/${id}/logo`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default companyService;
